import { useFormikContext } from 'formik';
import { Button, Flex, TextButton } from '@zillow/constellation';
import React from 'react';
import { useTheme } from 'styled-components';
import { IOrderParams } from '../../../API/pcDashboard/getOrderAsync';
import { initialDashboardQueryObject } from '../DashboardContainer';
import { useHasFeatureFlag } from '../../../selectors/useHasFeatureFlag';
import { Button as SpruceButton } from '../../../ui-toolkit/components/Button/Button';

export const FilterButtonsRow: React.FC = () => {
  const { dirty, isValid } = useFormikContext();
  const isZillowClosingEnabled = useHasFeatureFlag('pinecone.zillow-closing');

  if (!isZillowClosingEnabled) {
    return (
      <Flex display={'flex'} flexDirection={'row-reverse'} gap={'sm'}>
        <SpruceButton type={'submit'} intent={'primary'} disabled={!dirty || !isValid}>
          Filter
        </SpruceButton>
        <SpruceButton type={'reset'} intent={'secondary'} disabled={!dirty}>
          Reset Form
        </SpruceButton>
        <EmptyButton useSpruceColors={true} />
      </Flex>
    );
  }

  return (
    <Flex display={'flex'} flexDirection={'row-reverse'} gap={'sm'}>
      <Button type={'submit'} buttonType={'primary'} disabled={!dirty || !isValid}>
        Filter
      </Button>
      <Button type={'reset'} buttonType={'secondary'} disabled={!dirty}>
        Reset Form
      </Button>
      <EmptyButton useSpruceColors={false} />
    </Flex>
  );
};

const EmptyButton: React.FC<{ useSpruceColors: boolean }> = ({ useSpruceColors }) => {
  const { setValues } = useFormikContext<IOrderParams>();
  const theme = useTheme();
  return (
    <TextButton
      type={'button'}
      onClick={() => {
        setValues(initialDashboardQueryObject);
      }}
      style={useSpruceColors ? { color: theme.colors.spruceDarkGreen } : undefined}
    >
      Empty All Filters
    </TextButton>
  );
};
